import type { ShareVoiceSidebarCategory } from "@/data-access/share-of-voice/queries/shareOfVoice-sidebar-filter-queries";
export const DISCOVERED_TAG_CATEGORIES: ReadonlySet<ShareVoiceSidebarCategory> =
  new Set(["PEOPLE", "TOPIC", "EVENT", "INITIATIVE", "THEME"]);
